module.exports = __webpack_public_path__ + "static/media/pipe_down.a71b7837.png";